import http from '@/services/http'
import type * as Types from './type'

/** 库存同步的开关接口 */
export const stockSettingUpdate = async (data) => http.admin.post('/api/stock/sync/setting/update', data)

/**
 * @deprecated
 * 获取公共规则
 */
export const getCommonRules = async (data) => http.admin.get('/api/stock/sync/rule/blanket/getRules', data)

/** 获取自定义规则组信息 */
export const getCustomGroups = async () => http.admin.get<Types.GetGroupsRes>('/api/stock/sync/rule/custom/getGroups')

/**
 * @deprecated
 * 获取自定义规则组对应的商品和规则
 */
export const listByGroups = async (data) => http.admin.post('/api/stock/sync/rule/custom/listByGroups', data)

/** 获取无需同步商品列表 */
export const getBlacklist = async (data: Types.SkuBlacklistSearchReqDTO) => http.admin.post<Types.BlacklistListRes>('/api/stock/sync/rule/blacklist/list', data)

/** 保存配置接口 */
export const saveOrUpdate = async (data) => http.admin.post('/api/stock/sync/rule/saveOrUpdate', data)

/** 查询单个分组规则 */
export const getRules = async (data) => http.admin.get('/api/stock/sync/rule/custom/getRules/' + data.ruleGroupId, data)

/** 查询分组对应商品列表 */
export const getSkuInfoIds = async (data) => http.admin.get('/api/stock/sync/rule/custom/getSkuInfoIds/' + data.ruleGroupId, data)

/** 库存同步获取通用规则 */
export const getCommonAllRules = async () => http.admin.get<Types.GetAllRulesRes>('/api/stock/sync/rule/blanket/getAllRules')
/** 查询单个规则 */
export const getSelfCustomAllRules = async (data: Types.ListAllByGroupsReq) => http.admin.post<Types.ListAllByGroupsRes>('/api/stock/sync/rule/custom/listAllByGroups', data)

/** 
查询当前用户是否有自动库存同步任务正在执行 */
export const hasAutoStockSyncTaskRunning = async () => http.admin.get<Types.HasAutoStockSyncTaskRunningRes>('/api/stock/sync/setting/hasAutoStockSyncTaskRunning')
